// Filename - components/Sidebar.js

import React, { useState,useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { SidebarData } from "./sidebardata";
import SubMenu from "./submenu";
import UserMenu from "../usermenu";
import { IconContext } from "react-icons/lib";
import '../../styles/sidebar.css';
import {ip_back , api_key} from '../../constants/appConstants';

const Nav = styled.div`
    background: #15171c;
    height: 80px;
    display: flex;
    justify-content: space-between;;
    align-items: center;
    margin-bottom: 50px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
    top: 0;
    left: 0;
    width: 100%;
    padding-right: 10px;
`;

const NavContainer=styled.div `
    display: flex;
    align-items: center;
`;

const NavTitle=styled.div `
    font-size: 24px;
    font-weight: bold;
    color: white;
    white-space: nowrap;
    margin-right: 20px;
`;

const NavUserMenu=styled(UserMenu)`
    display: flex;
    align-items: center;
`;

const NavIcon = styled(Link)`
    margin-left: 2rem;
    font-size: 2rem;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background: #15171c;
`;

const SidebarNav = styled.nav`
    background: rgba(21,23,28,0.5);
    width: 250px;
    height: 100vh;
    display: flex;
    justify-content: center;
    position: fixed;
    top: 0;
    left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
    transition: 350ms;
    z-index: 10;
`;

const SidebarWrap = styled.div`
    width: 100%;
`;

const Sidebar = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false); // Para mostrar u ocultar el menú
  const [menuItems, setMenuItems] = useState([]); // Para guardar los ítems del menú

  useEffect(() => {
    const fetchRoles = async () => {
      const storedUser = JSON.parse(localStorage.getItem("user"));
      const token = JSON.parse(localStorage.getItem("token"));

      const response = await fetch(`${ip_back}/api/usuarios/roles_usuario`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": api_key,
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ usuario: storedUser }),
      });

      if (response.ok) {
        const json = await response.json();
        const tieneRolAdmin = json.roles?.some(
          (rol) => rol.nombre === "ADMINISTRADOR"
        );
        const menu = SidebarData(tieneRolAdmin);
        setMenuItems(menu);
      }
    };

    fetchRoles();
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <IconContext.Provider value={{ color: "#fff" }}>
      <Nav>
        <NavIcon to="#">
          <FaIcons.FaBars onClick={toggleSidebar} />
        </NavIcon>
        <NavContainer>
          <NavTitle>Camacho Asesores</NavTitle>
          <NavUserMenu>
            <UserMenu />
          </NavUserMenu>
        </NavContainer>
      </Nav>
      <SidebarNav sidebar={isSidebarOpen}>
        <SidebarWrap>
          <NavIcon to="#">
            <AiIcons.AiOutlineClose onClick={toggleSidebar} />
          </NavIcon>
          {menuItems.map((item, index) => (
            <SubMenu item={item} key={index} />
          ))}
        </SidebarWrap>
      </SidebarNav>
    </IconContext.Provider>
  );
};


export default Sidebar;